import { createFileRoute } from '@tanstack/react-router';
import { TimesheetReasonsConsole } from '@/features/timesheet/ReasonsConsole';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileTimesheetReasons } from '@/features/timesheet/mobile/MobileTimesheetReasons';

/**
 * Causali di attività: catalogo MaeDesign con il comportamento di ogni causale
 * (fatturabile, straordinario, trasferta, obbligo di commessa/giustificativo).
 * Sostituisce la `ResourceListPage` generica mantenendone le funzioni.
 */
export const Route = createFileRoute('/_app/timesheet/reasons')({ component: TimesheetReasonsPage });

/** Selettore mobile/desktop: su telefono il comportamento della causale sta sulla card. */
function TimesheetReasonsPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileTimesheetReasons /> : <TimesheetReasonsConsole />;
}
